export default __webpack_public_path__ + "static/media/inoversidade-logo.b09a544c.svg";